import {Col, Row} from 'react-bootstrap';
import {useAuthContext, useLanguageContext, useThemeContext} from '../../../context';
import {TextField, Header, MessageModal} from '../../common';
import {useState, useEffect} from 'react';
import {getAccountBusiness, getHashMap, getLocationNames, toSnakeCase, validateDiscountForm, validateDraftDiscount} from '../../../constants';
import {useNavigate} from 'react-router-dom';
import {Sync} from '../../../api';
import LocationModal from '../LocationModal';
import {bulkCreateDiscountBusiness} from '../../../pos-core/database/helpers/discountBusiness';

const CreateDiscountComponent = ({discount}) => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const {user, business, setRenderToast, account, userBusiness} = useAuthContext();

    let navigate = useNavigate();

    const [name, setName] = useState(discount?.name || '');
    const [location, setLocation] = useState(null);
    const [locationModal, setLocationModal] = useState(false);
    const [selectedLocations, setSelectedLocations] = useState({});
    const [locationsObj, setLocationsObj] = useState();
    const [tax_behavior, setTaxBehavior] = useState(discount ? I18n[discount.is_inclusive ? 'tax_inclusive' : 'tax_exclusive'] : '');
    const [discount_type, setDiscountType] = useState(discount ? I18n[discount.type == 'percentage' ? 'type_percentage' : 'type_amount'] : '');
    const [discardModalToggle, setDiscardModalToggle] = useState(false);
    const [amount_limit, setAmountLimit] = useState(discount?.limit || '');
    const [max_discount_cap, setMaxDiscountCap] = useState(discount?.max_discount_cap || '');
    const [errors, setErrors] = useState({});

    const discountType = [I18n.type_amount, I18n.type_percentage];

    const onChange = (label, val) => {
        if (label == I18n.discounts_name) setName(val);
        else if (label == I18n.taxation_behaviour) setTaxBehavior(val);
        else if (label == I18n.amount_type) setDiscountType(val);
        else if (label == I18n.amount) setAmountLimit(val);
        else if (label == I18n.maximum_discount_cap) setMaxDiscountCap(val);
        else if (label == I18n.location) setLocationModal(true);

        setErrors(prevErrors => {
            const updatedErrors = {...prevErrors};
            if (updatedErrors[toSnakeCase(label)]) {
                delete updatedErrors[toSnakeCase(label)];
            }
            return updatedErrors;
        });
    };

    const handleCreate = async val => {
        const {draft, id} = discount || {};
        try {
            if (selectedLocations.hasOwnProperty('all')) {
                delete selectedLocations['all'];
            }
            const locationsArray = Object.values(selectedLocations || {}).map(item => locationsObj[item]);

            let paramsForDiscount = {
                name,
                is_inclusive: tax_behavior == I18n.tax_inclusive ? true : false,
                type: discount_type == I18n.type_amount ? 'amount' : discount_type == I18n.type_percentage ? 'percentage' : '',
                limit: Number(amount_limit),
                max_discount_cap: max_discount_cap ? Number(max_discount_cap) : null,
                draft: val === 'saveDraft',

                locationsArray,
            };
            let createdDiscount;

            const formErrors = await (val === 'save' ? validateDiscountForm(paramsForDiscount) : validateDraftDiscount(paramsForDiscount));
            setErrors(formErrors);
            console.log('form errors', formErrors);

            if (Object.keys(formErrors).length > 0) return;

            if (discount) {
                createdDiscount = await discount.updateDetails(paramsForDiscount);
            } else {
                createdDiscount = await account.createDiscount(paramsForDiscount);
                console.log('created disc', createdDiscount);
                const discountBussPayload = {
                    locations: locationsArray,
                    discount: createdDiscount,
                };

                const response = bulkCreateDiscountBusiness(discountBussPayload);
                console.log('created disc business', response);
            }

            let toastMessage;
            if (val === 'saveDraft') {
                toastMessage = 'discount_saved_into_draft';
            } else {
                toastMessage = draft ? 'discount_published_successfully' : id ? 'discount_update' : 'discount_created';
            }

            setRenderToast(toastMessage);
            Sync(user?.username);
            navigate(-1);
        } catch (error) {
            console.log(error);
        }
    };

    const toggleDiscardModal = () => {
        setDiscardModalToggle(x => !x);
    };

    const handleDiscardAction = () => {
        navigate(-1);
    };

    const handleEnterPress = event => {
        if (event?.key === 'Enter') {
            handleCreate('save');
        }
    };

    const getBusinessOfAccount = async () => {
        const singleSelection = false;
        const businessLocations = await getAccountBusiness(account, business, userBusiness, singleSelection);
        const businessObj = await getHashMap(account);

        if (discount) {
            const discountBusiness = await discount.getDiscBusiness();
            const businessId = discountBusiness[0]?.business.id;
            setSelectedLocations({[businessId]: businessId});
        }

        setLocation(businessLocations);
        setLocationsObj(businessObj);
    };

    useEffect(() => {
        getBusinessOfAccount();
    }, []);

    useEffect(() => {
        // for handling location field, onchange isn't working there
        if (Object.values(selectedLocations || {}).length > 0) {
            setErrors(prevErrors => {
                const updatedErrors = {...prevErrors};
                let label = 'Location';
                if (updatedErrors[toSnakeCase(label)]) {
                    delete updatedErrors[toSnakeCase(label)];
                }

                return updatedErrors;
            });
        }
    }, [selectedLocations]);

    return (
        <>
            <div onKeyDown={handleEnterPress}>
                <Header
                    type="draftHeader"
                    title={I18n.back}
                    saveCta={{
                        title: I18n.save,
                        action: () => handleCreate('save'),
                    }}
                    primaryCta={
                        !discount?.id
                            ? {
                                  title: I18n.save_draft,
                                  action: () => handleCreate('saveDraft'),
                              }
                            : null
                    }
                />

                <Row className="justify-content-md-center">
                    <Col md={6}>
                        <div className="signupTextBox">
                            <h3 className="fontSize24  textCenter fontWeight600 marBot20 marTop0" style={{color: theme.text}}>
                                {I18n.create_discount}
                            </h3>
                            <h3 className="fontSize20 fontWeight400 marBot15 marLeft15 marTop0" style={{color: theme.text}}>
                                {I18n.discount_details}
                            </h3>

                            <div className="itemFields">
                                <TextField
                                    onChange={onChange}
                                    error={errors['discount_name']}
                                    label={I18n.discounts_name}
                                    placeholder={I18n.discounts_name}
                                    value={name}
                                    autoFocus={true}
                                    required={true}
                                />
                                <div className="intventoryFormGridTwo">
                                    <div className="priceSectionInputLeft">
                                        <TextField
                                            label={I18n.amount_type}
                                            placeholder={I18n.amount_type}
                                            error={errors['amount_type']}
                                            onChange={onChange}
                                            data={discountType}
                                            required={true}
                                            value={discount_type}
                                            inputType="select"
                                            type="text"
                                            suffix="downIcon2"
                                            suffix_fill={theme.white}
                                            suffix_width={'24'}
                                            suffix_height={'24'}
                                            suffix_viewBox={'0 0 18 18'}
                                        />
                                    </div>
                                    <div className="priceSectionInputRight">
                                        <TextField
                                            onChange={onChange}
                                            error={errors['amount']}
                                            label={I18n.amount}
                                            placeholder={I18n.amount}
                                            value={amount_limit}
                                            type={'numeric'}
                                            required={true}
                                        />
                                    </div>
                                </div>

                                <div className="intventoryFormGridTwo">
                                    <div className="priceSectionInputLeft">
                                        <TextField
                                            onChange={onChange}
                                            label={I18n.maximum_discount_cap}
                                            placeholder={I18n.maximum_discount_cap}
                                            value={max_discount_cap}
                                            type={'numeric'}
                                        />
                                    </div>
                                    <div onClick={() => !discount && setLocationModal(true)} className="priceSectionInputRight">
                                        <TextField
                                            label={I18n.location}
                                            placeholder={I18n.location}
                                            error={errors?.['location']}
                                            onChange={onChange}
                                            value={getLocationNames(locationsObj, selectedLocations)}
                                            inputType="text"
                                            type="text"
                                            suffix="downIcon2"
                                            suffix_fill={theme.white}
                                            suffix_width={'24'}
                                            suffix_height={'24'}
                                            suffix_viewBox={'0 0 18 18'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <LocationModal
                toggle={locationModal}
                setToggle={setLocationModal}
                selectedLocations={selectedLocations}
                setSelectedLocations={setSelectedLocations}
                locations={location}
                singleSelection={false}
            />
            <MessageModal
                className="messageModal"
                setToggle={setDiscardModalToggle}
                toggle={discardModalToggle}
                description={I18n.do_you_really_want_to_discard}
                subDescription={I18n.this_action_is_irreversible_once_you_discard_it_its_gone}
                secondaryCta={{
                    title: I18n.cancel,
                    action: toggleDiscardModal,
                }}
                primaryCta={{
                    title: I18n.discard,
                    backgroundColor: theme.white,
                    borderColor: theme.red,
                    txtColor: theme.red,
                    action: handleDiscardAction,
                    isDelete: true,
                }}
            />
        </>
    );
};

export default CreateDiscountComponent;
